
import HintTooltip from '@/ui-kit/components/tooltip/hint-tooltip';
import { HintTooltipProperty } from '@/ui-kit/components/tooltip/enum';
import Icon from '@/ui-kit/components/icon';
import IconHintTooltipProps from './mixins/IconHintTooltipProps';
import { IconType, IconProperty } from '@/ui-kit/components/icon/enums';
import {
  StyleSizeType,
  StyleColorSchemeType,
} from '@/ui-kit/styles/enums';
import { IconHintTooltipProperty } from './enum';

export default {
  name: 'IconHintTooltip',
  components: { HintTooltip, Icon },
  mixins: [IconHintTooltipProps],
  data() {
    return {
      IconType,
      IconProperty,
      StyleColorSchemeType,
      StyleSizeType,
      HintTooltipProperty,
      IconHintTooltipProps,
      IconHintTooltipProperty,
    };
  },
};
